import { __assign } from "tslib";
import * as actionTypes from '../constants/actionTypes';
export function missClick(eventData) {
    return __assign({ type: actionTypes.MISS_CLICK }, eventData);
}
export function mouseMove(eventData) {
    return __assign({ type: actionTypes.MOVE_MOUSE }, eventData);
}
